import * as React from "react";
import OverlayDropdownButton from "components/common/OverlayDropdownButton";
import { MORE_ACTIONS_TITLE, MORE_ACTIONS_HOVER_TITLE } from "./Constants";
const MoreActions = ({ children = void 0, disabled = false }) => /* @__PURE__ */ React.createElement(
  OverlayDropdownButton,
  {
    title: MORE_ACTIONS_TITLE,
    bsSize: "xsmall",
    buttonTitle: MORE_ACTIONS_HOVER_TITLE,
    disabled
  },
  children
);
export default MoreActions;
